<div class="page-content" [ngClass]="{'dark': theme === 'dark', 'light': theme === 'light'}">
  <app-header></app-header>
  <app-graph-table style="margin: 40px 13% 0px 13%;" (search)="onSearch($event)"
    *ngIf="searchSelected == null"></app-graph-table>
  <app-graph-component [element]="element" (goBack)="goBack($event)"
    *ngIf="searchSelected != null"></app-graph-component>
</div>